import React, { memo } from 'react';
import { CheckCircle, Brain, Zap, Clock, ArrowRight } from 'lucide-react';
export function SolutionSection() {
  const scrollToPurchase = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-16 bg-white px-4" data-id="element-131">
      <div className="max-w-5xl mx-auto" data-id="element-132">
        <div className="text-center mb-12" data-id="element-133">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-134">
            ✅ La solución: estudiar Anatomía como tu cerebro realmente aprende
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-135">
            Mapas Mentales de Anatomía Humana está diseñado para:
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-12" data-id="element-136">
          <div className="bg-blue-50 p-8 rounded-2xl text-center hover:shadow-lg transition-shadow" data-id="element-137">
            <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-138">
              <Brain className="w-8 h-8 text-blue-600" data-id="element-139" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-140">
              Comprender primero
            </h3>
            <p className="text-gray-600" data-id="element-141">
              Entiende la lógica de las estructuras antes de intentar
              memorizarlas.
            </p>
          </div>

          <div className="bg-blue-50 p-8 rounded-2xl text-center hover:shadow-lg transition-shadow" data-id="element-142">
            <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-143">
              <Zap className="w-8 h-8 text-blue-600" data-id="element-144" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-145">
              Memorizar después
            </h3>
            <p className="text-gray-600" data-id="element-146">
              Fija el conocimiento con técnicas visuales que se adhieren a tu
              memoria.
            </p>
          </div>

          <div className="bg-blue-50 p-8 rounded-2xl text-center hover:shadow-lg transition-shadow" data-id="element-147">
            <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-148">
              <Clock className="w-8 h-8 text-blue-600" data-id="element-149" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-150">
              Rendir mejor
            </h3>
            <p className="text-gray-600" data-id="element-151">
              Optimiza tu tiempo de estudio y obtén mejores resultados en menos
              tiempo.
            </p>
          </div>
        </div>

        <div className="text-center bg-gray-50 p-8 rounded-2xl border border-gray-200" data-id="element-152">
          <p className="text-xl text-gray-800 font-medium mb-8" data-id="element-153">
            Utiliza mapas mentales, esquemas visuales y recursos prácticos para
            que dejes de memorizar sin entender.
          </p>

          <button onClick={scrollToPurchase} className="inline-flex items-center justify-center gap-2 bg-green-600 hover:bg-green-500 text-white font-bold text-lg py-4 px-8 rounded-lg shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1" data-id="element-154">
            ¡SÍ, QUIERO APROBAR ANATOMÍA!
            <ArrowRight className="w-5 h-5" data-id="element-155" />
          </button>
        </div>
      </div>
    </section>;
}